import styled, { css } from "styled-components";
import { Popover as PopoverPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

type PopoverProps = {
  $width?: number;
};

export const Popover = styled(PopoverPrimitive)<PopoverProps>`
  ${({ $width }) => {
    const {
      tokens: {
        select,
        scrollBar: { thumbColor, trackColor },
      },
    } = useDesignTokens();

    return [
      css`
        display: grid;
        grid-template-rows: 1fr;
        width: var(--trigger-width);
        border-radius: ${select.menu.radius};
        border-width: ${select.menu.stroke.width};
        border-style: ${select.menu.stroke.style};
        border-color: ${select.menu.stroke.color};
        box-shadow: 0px 2px 2px ${select.menu.shadow.outer.color};
        background: ${select.menu.backgroundColor.base};
        scrollbar-color: ${thumbColor} ${trackColor};
        z-index: ${select.menu.zIndex};
        overflow: hidden;
      `,
      $width &&
        css`
          width: ${$width}px;
        `,
    ];
  }}
`;
